<template>
  <div class="home-page">
    <!-- 顶部横幅区域 -->
    <div class="hero-banner">
      <div class="banner-background">
        <div class="animated-lines"></div>
        <div class="animated-dots"></div>
        <div class="city-skyline"></div>
        <div class="gear-icon">⚙</div>
        <div class="house-icon">🏠</div>
      </div>
      <div class="banner-content">
        <h1 class="main-title animate-fade-in-up">促进成果技术产业化,推动重点产业升级</h1>
        <p class="subtitle animate-fade-in-up-delay">立足新疆、服务企业、连通中亚的技术转移创新枢纽</p>
      </div>
    </div>

    <!-- 关键指标区域 -->
    <div class="metrics-section">
      <div class="metrics-container">
        <div 
          v-for="(metric, index) in metrics" 
          :key="index"
          class="metric-item"
          :style="{ animationDelay: `${index * 0.1}s` }"
        >
          <div class="metric-number animate-count-up">{{ formatNumber(metric.displayValue || metric.value) }}</div>
          <div class="metric-label">{{ metric.label }}</div>
        </div>
      </div>
    </div>

    <!-- 新闻动态区域 -->
    <div class="news-section">
      <div class="news-container">
        <h2 class="section-title">新闻动态</h2>
        <div class="news-content">
          <!-- 左侧图片轮播 -->
          <div class="news-carousel">
            <swiper v-if="carouselItems.length > 0" :options="swiperOptions" ref="newsSwiper">
              <swiper-slide v-for="(item, index) in carouselItems" :key="index">
                <a :href="'/cms/detail?id='+item.id" target="_blank">
                  <div class="carousel-item">
                  <img
                    :src="item.image"
                    :alt="item.title"
                    @error="markCoverBroken(item.cmsData)"
                  />
                  <div class="carousel-caption">
                    <p>{{ item.title }}</p>
                  </div>
                </div>
                </a>
                
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
            <!-- 加载状态或空状态 -->
            <div v-else class="carousel-placeholder">
              <div class="placeholder-content">
                <div class="loading-spinner" v-if="loading"></div>
                <div class="no-data" v-else>暂无内容</div>
              </div>
            </div>
          </div>

          <!-- 右侧新闻列表 -->
          <div class="news-list">
            <div class="news-header">
              <span class="view-more"><router-link to="/cms/list">查看更多></router-link></span>
            </div>
            <ul class="news-items">
              <li 
                v-for="(news, index) in newsList" 
                :key="index"
                class="news-item"
                @click="handleNewsClick(news)"
              >
                <span class="news-title">{{ news.title }}</span>
                <span class="news-date">{{ news.date }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import { getAction, getFileAccessHttpUrl } from "@/api/manage"

export default {
  name: 'Home',
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      metrics: [
        { value: 0, displayValue: 0, label: '技术成果' },
        { value: 0, displayValue: 0, label: '技术需求' },
        { value: 8, displayValue: 0, label: '技术合同成交额(亿元)' },
        { value: 8176, displayValue: 0, label: '技术专家' },
        { value: 178, displayValue: 0, label: '技术经纪人' }
      ],
      cmsData: [],
      loading: false,
      carouselItems: [],
      newsList: [],
      imageErrorTimer: null,
      swiperOptions: {
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        }
      },
      timers: []
    }
  },
  methods: {
    getFileAccessHttpUrl,
    formatNumber(num) {
      return num.toLocaleString('zh-CN')
    },
    getCmsCover(item) {
      if (!item.cmsCover) {
        return "";
      }
      return this.getFileAccessHttpUrl(item.cmsCover);
    },
    markCoverBroken(item) {
      this.$set(item, "_coverBroken", true);
      // 防抖处理，避免频繁重新渲染
      if (this.imageErrorTimer) {
        clearTimeout(this.imageErrorTimer);
      }
      this.imageErrorTimer = setTimeout(() => {
        this.processCmsData();
        this.imageErrorTimer = null;
      }, 100);
    },
    getMetricsCount() {
      getAction("/xjtech/techAchievement/getCount")
        .then((res) => {
          if (res.success) {
            // 更新技术成果和技术需求数量
            this.metrics.forEach((metric, index) => {
              if (metric.label === '技术成果') {
                this.$set(this.metrics[index], 'value', res.result.achievementCount || 0);
              } else if (metric.label === '技术需求') {
                this.$set(this.metrics[index], 'value', res.result.requirementCount || 0);
              }
            });
          }
        })
        .catch((error) => {
          console.error('获取统计数据失败:', error);
        });
    },
    getCmsList() {
      this.loading = true;
      this.cmsData = [];
      getAction("/teaching/teachingCms/getCmsList", {
        cmsStatus: 1,
        pageSize: 20,
      }).then((res) => {
        if (res.success) {
          this.cmsData = res.result.records || [];
          this.processCmsData();
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    processCmsData() {
      // 处理数据：有封面的文章添加到轮播图，无封面的添加到新闻列表
      const carouselData = [];
      const newsData = [];

      this.cmsData.forEach(item => {
        if (item.cmsCover && !item._coverBroken) {
          // 有封面的文章添加到轮播图
          carouselData.push({
            id: item.id,
            image: this.getCmsCover(item),
            title: item.cmsTitile,
            cmsData: item
          });
        } 
        // else {
          // 无封面的文章添加到新闻列表
          newsData.push({
            id: item.id,
            title: item.cmsTitile,
            date: item.createTime,
            cmsData: item
          });
        // }
      });

      // 限制轮播图最多显示6张
      const newCarouselItems = carouselData.slice(0, 6);
      // 限制新闻列表最多显示9条
      const newNewsList = newsData.slice(0, 9);

      // 只有当数据真正发生变化时才更新，避免不必要的重新渲染
      const carouselChanged = this.carouselItems.length !== newCarouselItems.length ||
        !this.carouselItems.every((item, index) =>
          newCarouselItems[index] && item.id === newCarouselItems[index].id
        );

      const newsChanged = this.newsList.length !== newNewsList.length ||
        !this.newsList.every((item, index) =>
          newNewsList[index] && item.id === newNewsList[index].id
        );

      if (carouselChanged) {
        this.carouselItems = newCarouselItems;
      }

      if (newsChanged) {
        this.newsList = newNewsList;
      }
    },
    handleNewsClick(news) {
      // 处理新闻点击事件
      console.log('点击新闻:', news)
      // 跳转到详情页
      if (news.id) {
        let route = this.$router.resolve({
          path: "/cms/detail",
          query: {
            id: news.id,
          },
        });
        window.open(route.href, '_blank');
      }
    }
  },
  mounted() {
    // 获取统计数据
    this.getMetricsCount()

    // 获取文章数据
    this.getCmsList()

    // 数字计数动画
    this.metrics.forEach((metric, index) => {
      const targetValue = metric.value
      const duration = 2000
      const steps = 60
      const increment = targetValue / steps
      let current = 0
      const timer = setInterval(() => {
        current += increment
        if (current >= targetValue) {
          current = targetValue
          clearInterval(timer)
          const timerIndex = this.timers.indexOf(timer)
          if (timerIndex > -1) {
            this.timers.splice(timerIndex, 1)
          }
        }
        this.$set(this.metrics[index], 'displayValue', Math.floor(current))
      }, duration / steps)
      this.timers.push(timer)
    })
  },
  beforeDestroy() {
    // 清理定时器
    this.timers.forEach(timer => clearInterval(timer))
    this.timers = []
    // 清理图片错误处理定时器
    if (this.imageErrorTimer) {
      clearTimeout(this.imageErrorTimer)
      this.imageErrorTimer = null
    }
  }
}
</script>

<style lang="less" scoped>
.home-page {
  width: 100%;
  min-height: 100vh;
  background: #f5f7fa;
}

// 顶部横幅区域
.hero-banner {
  position: relative;
  width: 100%;
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #1a3a5c 0%, #2d5a8a 100%);
  overflow: hidden;
  padding: 80px 20px;

  .banner-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;

    .animated-lines {
      position: absolute;
      width: 100%;
      height: 100%;
      background: 
        linear-gradient(90deg, transparent 0%, rgba(74, 144, 226, 0.3) 50%, transparent 100%),
        linear-gradient(0deg, transparent 0%, rgba(74, 144, 226, 0.2) 50%, transparent 100%);
      background-size: 200px 200px, 200px 200px;
      animation: lineMove 20s linear infinite;
      opacity: 0.6;
    }

    .animated-dots {
      position: absolute;
      width: 100%;
      height: 100%;
      background-image: 
        radial-gradient(circle, rgba(74, 144, 226, 0.4) 2px, transparent 2px);
      background-size: 50px 50px;
      animation: dotMove 15s linear infinite;
      opacity: 0.5;
    }

    .city-skyline {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 150px;
      background: linear-gradient(to top, rgba(0, 0, 0, 0.3) 0%, transparent 100%);
      clip-path: polygon(
        0% 100%, 5% 80%, 10% 90%, 15% 70%, 20% 85%, 25% 75%, 
        30% 95%, 35% 65%, 40% 80%, 45% 70%, 50% 90%, 55% 75%, 
        60% 85%, 65% 70%, 70% 95%, 75% 80%, 80% 90%, 85% 75%, 
        90% 85%, 95% 70%, 100% 100%
      );
      opacity: 0.3;
    }

    .gear-icon,
    .house-icon {
      position: absolute;
      font-size: 60px;
      opacity: 0.2;
      animation: float 6s ease-in-out infinite;
    }

    .gear-icon {
      top: 20%;
      right: 15%;
      animation-delay: 0s;
    }

    .house-icon {
      bottom: 20%;
      left: 10%;
      animation-delay: 3s;
    }
  }

  .banner-content {
    position: relative;
    z-index: 2;
    text-align: center;
    max-width: 1200px;
    margin: 0 auto;

    .main-title {
      font-size: 42px;
      font-weight: bold;
      color: #ffffff;
      margin-bottom: 20px;
      line-height: 1.4;
      text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    }

    .subtitle {
      font-size: 20px;
      color: rgba(255, 255, 255, 0.9);
      line-height: 1.6;
    }
  }
}

// 关键指标区域
.metrics-section {
  width: 100%;
  padding: 60px 20px;
  background: linear-gradient(135deg, #4a90e2 0%, #50c878 100%);

  .metrics-container {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    gap: 30px;

    .metric-item {
      flex: 1;
      min-width: 180px;
      text-align: center;
      padding: 30px 20px;
      animation: slideInUp 0.8s ease-out both;

      .metric-number {
        font-size: 48px;
        font-weight: bold;
        color: #ffffff;
        margin-bottom: 10px;
        text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
        transition: transform 0.3s ease;

        &:hover {
          transform: scale(1.1);
        }
      }

      .metric-label {
        font-size: 16px;
        color: rgba(255, 255, 255, 0.95);
        font-weight: 500;
      }
    }
  }
}

// 新闻动态区域
.news-section {
  width: 100%;
  padding: 60px 20px;
  background: #ffffff;

  .news-container {
    max-width: 1200px;
    margin: 0 auto;

    .section-title {
      font-size: 32px;
      font-weight: bold;
      color: #2c3e50;
      text-align: center;
      margin-bottom: 40px;
      position: relative;
      padding-bottom: 20px;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 80px;
        height: 4px;
        background: linear-gradient(90deg, #4a90e2, #50c878);
        border-radius: 2px;
      }
    }

    .news-content {
      display: flex;
      gap: 40px;
      align-items: flex-start;

      .news-carousel {
        flex: 1;
        min-width: 500px;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
        transition: transform 0.3s ease;

        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
        }

        .carousel-item {
          position: relative;
          width: 100%;
          height: 400px;
          overflow: hidden;
          cursor: pointer;
          transition: transform 0.3s ease, box-shadow 0.3s ease;

          &:hover {
            transform: translateY(-5px);
            box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);

            .carousel-caption {
              background: linear-gradient(to top, rgba(0, 0, 0, 0.9), transparent);
            }
          }

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.5s ease;

            &:hover {
              transform: scale(1.05);
            }
          }

          .carousel-caption {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
            padding: 20px;
            color: #ffffff;

            p {
              margin: 0;
              font-size: 16px;
              line-height: 1.5;
            }
          }
        }

        /deep/ .swiper-pagination-bullet {
          background: #ffffff;
          opacity: 0.5;
          width: 10px;
          height: 10px;

          &.swiper-pagination-bullet-active {
            opacity: 1;
            background: #4a90e2;
          }
        }
      }

      .news-list {
        flex: 1;
        min-width: 400px;
        background: #ffffff;
        border-radius: 12px;
        padding: 20px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);

        .news-header {
          display: flex;
          justify-content: flex-end;
          margin-bottom: 20px;

          .view-more {
            color: #4a90e2;
            font-size: 14px;
            cursor: pointer;
            transition: color 0.3s ease;

            &:hover {
              color: #50c878;
              text-decoration: underline;
            }
          }
        }

        .news-items {
          list-style: none;
          padding: 0;
          margin: 0;

          .news-item {
            padding: 15px 0;
            border-bottom: 1px solid #f0f0f0;
            cursor: pointer;
            transition: all 0.3s ease;
            display: flex;
            justify-content: space-between;
            align-items: center;

            &:last-child {
              border-bottom: none;
            }

            &:hover {
              background: #f8f9fa;
              padding-left: 10px;
              border-left: 3px solid #4a90e2;
            }

            .news-title {
              flex: 1;
              color: #2c3e50;
              font-size: 15px;
              line-height: 1.6;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              margin-right: 15px;
            }

            .news-date {
              color: #8c8c8c;
              font-size: 13px;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }
}

// 动画定义
@keyframes lineMove {
  0% {
    transform: translateX(0) translateY(0);
  }
  100% {
    transform: translateX(200px) translateY(200px);
  }
}

@keyframes dotMove {
  0% {
    transform: translateX(0) translateY(0);
  }
  100% {
    transform: translateX(50px) translateY(50px);
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-20px) rotate(180deg);
  }
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fade-in-up {
  animation: fadeInUp 1s ease-out;
}

.animate-fade-in-up-delay {
  animation: fadeInUp 1s ease-out 0.3s both;
}

.animate-count-up {
  animation: countUp 2s ease-out;
}

@keyframes countUp {
  from {
    opacity: 0;
    transform: scale(0.5);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

// 响应式设计
@media (max-width: 1024px) {
  .news-content {
    flex-direction: column;

    .news-carousel,
    .news-list {
      min-width: 100%;
    }
  }

  .metrics-container {
    .metric-item {
      min-width: 150px;
    }
  }
}

@media (max-width: 768px) {
  .hero-banner {
    min-height: 300px;
    padding: 40px 20px;

    .banner-content {
      .main-title {
        font-size: 28px;
      }

      .subtitle {
        font-size: 16px;
      }
    }
  }

  .metrics-section {
    padding: 40px 20px;

    .metrics-container {
      .metric-item {
        min-width: 120px;
        padding: 20px 10px;

        .metric-number {
          font-size: 36px;
        }

        .metric-label {
          font-size: 14px;
        }
      }
    }
  }

  .news-section {
    padding: 40px 15px;

    .news-container {
      .section-title {
        font-size: 24px;
      }
    }
  }
}

// 轮播图占位符样式
.carousel-placeholder {
  width: 100%;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  border-radius: 12px;

  .placeholder-content {
    text-align: center;
    color: #999;

    .loading-spinner {
      width: 40px;
      height: 40px;
      border: 4px solid #f3f3f3;
      border-top: 4px solid #4a90e2;
      border-radius: 50%;
      animation: spin 1s linear infinite;
      margin: 0 auto 16px;
    }

    .no-data {
      font-size: 16px;
      color: #ccc;
    }
  }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
